import React from "react";

import {
  Pill,
  QueueRow,
  QueueRowMeta,
  QueueRowSymbol,
  RowHeading,
  RowPills,
  ScrollingQueueList,
} from "../../styles";
import { formatMarketDate } from "../../utils/format";
import { NO_PRICE_LABEL } from "../constants";
import { InstrumentListProps } from "../types";

export const InstrumentList: React.FC<InstrumentListProps> = ({
  instruments,
  selectedId,
  draftIds,
  isDisabled,
  listRef,
  onSelect,
}) => {
  const rows = instruments.map((instrument) => {
    const { id, symbol, name, exchange, isActive, lastPrice } = instrument;
    const priceMeta = lastPrice
      ? `Price ${formatMarketDate(lastPrice.date)}`
      : NO_PRICE_LABEL;
    const inactiveMeta = isActive ? "" : " · Inactive";
    return {
      id,
      symbol,
      meta: `${name} · ${exchange}${inactiveMeta}`,
      priceMeta,
      isStale: instrument.isStale,
      isManual: instrument.manualPricingOnly,
      hasDraft: draftIds.has(id),
      isSelected: id === selectedId,
      handleClick: () => onSelect(id),
    };
  });

  return (
    <ScrollingQueueList ref={listRef} aria-label="Instruments">
      {rows.map(
        ({
          id,
          symbol,
          meta,
          priceMeta,
          isStale,
          isManual,
          hasDraft,
          isSelected,
          handleClick,
        }) => (
          <li key={id}>
            <QueueRow
              type="button"
              disabled={isDisabled}
              $isSelected={isSelected}
              aria-pressed={isSelected}
              onClick={handleClick}
            >
              <RowHeading>
                <QueueRowSymbol>{symbol}</QueueRowSymbol>
                <RowPills>
                  {hasDraft && <Pill $tone="unknown">Draft</Pill>}
                  {isManual && <Pill $tone="unknown">Manual</Pill>}
                  {isStale && <Pill $tone="warning">Stale</Pill>}
                </RowPills>
              </RowHeading>
              <QueueRowMeta>{meta}</QueueRowMeta>
              <QueueRowMeta>{priceMeta}</QueueRowMeta>
            </QueueRow>
          </li>
        ),
      )}
    </ScrollingQueueList>
  );
};
